import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Brazilian CPF generator following Single Responsibility Principle
 */
export class CpfGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true } = options;

    // Generate first 9 digits
    const digits = this.randomDigits(9);
    
    // Calculate check digits
    const [firstCheck, secondCheck] = ChecksumCalculator.calculateCpfChecksum(digits);
    
    const cpf = digits + firstCheck + secondCheck;
    
    return formatted ? 
      `${cpf.substring(0, 3)}.${cpf.substring(3, 6)}.${cpf.substring(6, 9)}-${cpf.substring(9, 11)}` : 
      cpf;
  }
}